<template>
  <div id="app">
    <div class="admin-container">
      <!-- 侧边栏 -->
      <SideBar :active-menu="activeMenu" @menu-change="handleMenuChange"   @logout="showLogoutModal" />
      
      <!-- 主内容区 -->
      <div class="main-content">
        <DashBoard  ref="dashboard"
                   v-if="activeMenu === 'dashboard'"
                   @view-detail="hanleReservation"
                   @freshShow="freshShow"
                   @freshEnd="freshEnd"
                   />
        <EduAppointment v-if="activeMenu === 'edu-appointment'" 
            @show-add-user="showAddUserModal('edu')"
                        @view-detail="hanleReservation"
            />
        <SoundAppointment v-if="activeMenu === 'sound-appointment'" 
            @show-add-user="showAddUserModal('sound')"
              @view-detail="hanleReservation"
            />
        <UserManagement v-if="activeMenu === 'user-management'" 
          @show-add-user="showAddUserModal('add')"
          @show-user-detail="showUserDetailModal"
          @edit-user="showUserEditModal"
          @freshShow="freshShow"
          @freshEnd="freshEnd"
                        />
        <SystemSettings v-if="activeMenu === 'system-settings'" />
      </div>
    </div>
    
    <!-- 模态框组件
    <user-detail-modal />
    <user-edit-modal />
         -->
    <LogoutModal ref="logoutModal" @logout-confirmed="handleLogout" />
    <AddUserModal ref="addUserModal" 
                  />
    <UserDetailModal ref="userDetailModal" />
    <UserEditModal ref="userEditModal" @update-user="handleUpdateUser" />    
    <LoadingIndicator ref="loadingIndicator" message="数据刷新中..." />

    <CheckInfoDialog 
      :is-visible="showDetail"
        @appointment-updated="handleAppointmentUpdated"
      :appointment-data="selectedEduAppointment"
      :appointment-type="detailType"
      @close="showDetail = false"
    />  

  </div>
</template>

<script>
import SideBar from './modals/SideBar.vue'
import DashBoard from './modals/DashBoard.vue'
import EduAppointment from './modals/EduAppointment.vue'
import SoundAppointment from './modals/SoundAppointment.vue'
import UserManagement from './modals/UserManagement.vue'
import SystemSettings from './modals/SystemSettings.vue'
import LogoutModal from './modals/LogoutModal.vue'


import AddUserModal from './modals/AddUserModal.vue'
import UserDetailModal from './modals/UserDetailModal.vue'
import UserEditModal from './modals/UserEditModal.vue'
import LoadingIndicator from './modals/LoadingIndicator.vue'
import CheckInfoDialog from './modals/CheckInfoDialog.vue'

export default {
  name: 'App',
  components: {
    SideBar,
    DashBoard,
    EduAppointment,
    SoundAppointment,
    UserManagement,
    SystemSettings,
    UserDetailModal,
    UserEditModal,
    LogoutModal,
    LoadingIndicator,
    AddUserModal,
    CheckInfoDialog,
  },
  data() {
    return {
        selectedEduAppointment:{
            name:"xj",
            school:"大修",
            position:"teacher",
            phone:"13700000000",
            email:"123@qq.com",
            interest:'individual',
            status:"rejected",
            need:"xxx",
        },
        selectedUser:null,
        detailType:'sound',
        showDetail:false,
        activeMenu: 'dashboard',
    }
  },
  methods: {
    handleAppointmentUpdated(){
      if (this.activeMenu === 'dashboard') {
        this.$refs.dashboard.freshDashData();
      }
    },
    freshShow(){
      this.$refs.loadingIndicator.show();
    },
    freshEnd(){
        this.$refs.loadingIndicator.hide();
    },
    hanleReservation(item){
        this.selectedEduAppointment = item;
        this.detailType = item.resvType ;

        this.showDetail=true;
    },
     showAddUserModal(type) {
      this.$refs.addUserModal.show(type);
    },
        handleAddUser(userData) {
      console.log('Adding user:', userData);
      // Add logic to save user data
      // You might want to emit an event to UserManagement to refresh the user list
    },
        showUserDetailModal(user) {
      this.$refs.userDetailModal.show(user);
    },
    showUserEditModal(user) {
     const selectedUser = { ...user };

      this.$refs.addUserModal.show("modify",JSON.stringify(selectedUser));
    },
    handleUpdateUser(userData) {
      console.log('Updating user:', userData);
      // Add logic to update user data
    },
    async refreshUsers() {
      this.$refs.loadingIndicator.show();
      
      // Simulate API call
      try {
        await new Promise(resolve => setTimeout(resolve, 1500));
        // Refresh logic would go here
        console.log('Users refreshed');
      } catch (error) {
        console.error('Error refreshing users:', error);
      } finally {
        this.$refs.loadingIndicator.hide();
      }
    },
    handleMenuChange(menu) {
      this.activeMenu = menu
    },
     showLogoutModal() {
      this.$refs.logoutModal.show();
    },
      handleLogout() {
      console.log('User logged out');
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Noto Sans SC', sans-serif;
  background: #f5f9ff;
  color: #333;
  line-height: 1.6;
  overflow-x: hidden;
}

.admin-container {
  display: flex;
  min-height: 100vh;
}

        
        /* 侧边栏样式 */
        .sidebar {
            width: 260px;
            background: linear-gradient(180deg, #0d47a1 0%, #1a73e8 100%);
            color: white;
            padding: 1.5rem 0;
            position: sticky;
            top: 0;
            height: 100vh;
            box-shadow: 4px 0 15px rgba(0, 0, 0, 0.1);
            z-index: 100;
        }
        
        .admin-logo {
            display: flex;
            align-items: center;
            padding: 0 1.5rem 1.5rem;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
        
        .admin-logo h1 {
            font-size: 1.3rem;
            font-weight: 700;
            margin-left: 10px;
        }
        
        .logo-icon {
            font-size: 2rem;
            color: #ffd54f;
        }
        
        .sidebar-menu {
            margin-top: 2rem;
        }
        
        .menu-item {
            display: flex;
            align-items: center;
            padding: 0.9rem 1.5rem;
            color: rgba(255, 255, 255, 0.85);
            text-decoration: none;
            font-weight: 500;
            font-size: 1rem;
            transition: all 0.3s ease;
            border-left: 4px solid transparent;
        }
        
        .menu-item:hover, .menu-item.active {
            background: rgba(255, 255, 255, 0.1);
            color: white;
            border-left-color: #ffd54f;
        }
        
        .menu-item i {
            margin-right: 12px;
            width: 24px;
            text-align: center;
        }
        
        /* 主内容区 */
        .main-content {
            flex: 1;
            padding: 2rem;
        }
        
        .admin-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2rem;
            padding-bottom: 1.5rem;
            border-bottom: 1px solid #e0e6ef;
        }
        
        .admin-title {
            text-align:left;
            font-size: 1.8rem;
            color: #0d47a1;
            font-weight: 700;
        }
        
        .admin-actions {
            display: flex;
            gap: 15px;
        }
        
        .admin-btn {
            background: #1a73e8;
            color: white;
            border: none;
            padding: 10px 20px;
            border-radius: 6px;
            font-weight: 500;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 8px;
            transition: all 0.3s;
        }
        
        .admin-btn:hover {
            background: #0d47a1;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(13, 71, 161, 0.25);
        }
        
        .admin-btn.secondary {
            background: #f0f7ff;
            color: #1a73e8;
            border: 1px solid #1a73e8;
        }
        
        .admin-btn.secondary:hover {
            background: #e3f2fd;
        }
        
        /* 数据统计卡片 */
        .stats-container {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
            gap: 20px;
            margin-bottom: 2rem;
        }
        
        .stat-card {
            background: white;
            border-radius: 12px;
            padding: 1.5rem;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
            display: flex;
            flex-direction: column;
        }
        
        .stat-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;
        }
        
        .stat-title {
            text-align:left;
            font-size: 1rem;
            color: #555;
            font-weight: 500;
        }
        
        .stat-icon {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5rem;
        }
        
        .stat-icon.total {
            background: rgba(26, 115, 232, 0.15);
            color: #1a73e8;
        }
        
        .stat-icon.teachers {
            background: rgba(76, 175, 80, 0.15);
            color: #4caf50;
        }
        
        .stat-icon.students {
            background: rgba(255, 152, 0, 0.15);
            color: #ff9800;
        }
        
        .stat-icon.parents {
            background: rgba(156, 39, 176, 0.15);
            color: #9c27b0;
        }
        
        .stat-icon.sound {
            background: rgba(101, 87, 255, 0.15);
            color: #6557ff;
        }
        
        .stat-icon.hotel {
            background: rgba(255, 87, 87, 0.15);
            color: #ff5757;
        }
        
        .stat-value {
            text-align:left;
            font-size: 2.2rem;
            font-weight: 700;
            color: #0d47a1;
            margin-bottom: 0.5rem;
        }
        
        /* 数据表格 */
        .data-table-container {
            background: white;
            border-radius: 12px;
            padding: 1.5rem;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        }
        
        .table-controls {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.5rem;
        }
        
        .search-box {
            position: relative;
            width: 300px;
        }
        
        .search-box input {
            width: 100%;
            padding: 10px 15px 10px 40px;
            border: 1px solid #e0e6ef;
            border-radius: 6px;
            font-size: 0.95rem;
            transition: all 0.3s;
        }
        
        .search-box input:focus {
            border-color: #1a73e8;
            outline: none;
            box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);
        }
        
        .search-box i {
            position: absolute;
            left: 15px;
            top: 50%;
            transform: translateY(-50%);
            color: #888;
        }
        
        .filters {
            display: flex;
            gap: 15px;
        }
        
        .filter-select {
            padding: 10px 15px;
            border: 1px solid #e0e6ef;
            border-radius: 6px;
            background: white;
            font-size: 0.95rem;
            cursor: pointer;
        }
        
        .filter-select:focus {
            border-color: #1a73e8;
            outline: none;
        }
        
        .data-table {
            width: 100%;
            border-collapse: collapse;
        }
        
        .data-table th {
            text-align: left;
            padding: 12px 15px;
            background: #f5f9ff;
            color: #0d47a1;
            font-weight: 600;
            border-bottom: 1px solid #e0e6ef;
            white-space:nowrap;
        }
        
        .data-table td {
            padding: 12px 15px;
            border-bottom: 1px solid #eef2f7;
        }
        
        .data-table tr:hover td {
            background: #f8fbff;
        }
        
        .user-info {
            display: flex;
            align-items: center;
            gap: 12px;
        }
        
        .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: #e3f2fd;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #1a73e8;
            font-weight: 600;
        }
        
        .user-name {
            text-align:left;
            font-weight: 500;
            white-space:nowrap;
        }
        
        .user-school {
            text-align:left;
            font-size: 0.9rem;
            color: #666;
        }
        
        .status-badge {
          display: inline-block;
          padding: 4px 8px;
          border-radius: 18px;
          font-size: 15px;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          min-width: 60px;
          max-width: 100px;
          vertical-align: middle;
        }

        .status-badge.pending {
          background-color: #fff3cd;
          color: #856404;
        }

        .status-badge.contacted {
          background-color: #d1ecf1;
          color: #0c5460;
        }

        .status-badge.rejected {
          background-color: #f8d7da;
          color: #721c24;
        }
    
        .status-badge.· {
            background: #ffcdd2;
            color: #f44336;
        }
        
        .status-badge.scheduled {
            background: #bbdefb;
            color: #1976d2;
        }
        
        .status-badge.active {
          background-color: #d4edda;
          color: #155724;
        }

        .status-badge.inactive {
          background-color: #e2e3e5;
          color: #7a7b7c;
        }

        .status-badge.confirmed {
          background-color: #d4edda;
          color: #155724;
        }

        /* 确保表格单元格有足够的空间 */
        .data-table td {
          padding: 12px 16px;
          vertical-align: middle;
        }

        .action-btn {
            white-space: nowrap; 
            display: inline-flex;
            align-items: center;
            gap: 2px; 
            background: transparent;
            border: none;
            color: #1a73e8;
            cursor: pointer;
            padding: 6px;
            border-radius: 4px;
            transition: all 0.3s;
        }
        
        .action-btn:hover {
            background: rgba(26, 115, 232, 0.1);
        }
        
        .action-btn i {
            margin-right: 5px;
        }
        
        /* 分页 */
        .pagination {
            display: flex;
            justify-content: center;
            margin-top: 2rem;
            gap: 8px;
        }
        
        .pagination-btn {
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #e0e6ef;
            background: white;
            border-radius: 6px;
            cursor: pointer;
            font-size: 0.95rem;
            transition: all 0.3s;
        }
        
        .pagination-btn:hover, .pagination-btn.active {
            background: #1a73e8;
            color: white;
            border-color: #1a73e8;
        }
        
        /* 新增内容区域样式 */
        .content-section {
            display: none;
        }
        
        .content-section.active {
            display: block;
        }
        
        /* 用户管理样式 */
        .role-tabs {
            display: flex;
            margin-bottom: 1.5rem;
            border-bottom: 1px solid #e0e6ef;
        }
        
        .role-tab {
            padding: 10px 20px;
            cursor: pointer;
            font-weight: 500;
            color: #666;
            border-bottom: 3px solid transparent;
            transition: all 0.3s;
        }
        
        .role-tab.active {
            color: #1a73e8;
            border-bottom-color: #1a73e8;
        }
        
        .role-tab:hover {
            color: #0d47a1;
        }
        
        /* 系统设置样式 */
        .settings-container {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
            gap: 30px;
        }
        
        .setting-card {
            background: white;
            border-radius: 12px;
            padding: 1.5rem;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        }
        
        .setting-header {
            display: flex;
            align-items: center;
            margin-bottom: 1.5rem;
            padding-bottom: 1rem;
            border-bottom: 1px solid #eef2f7;
        }
        
        .setting-header i {
            font-size: 1.5rem;
            color: #1a73e8;
            margin-right: 12px;
        }
        
        .setting-header h3 {
            font-size: 1.2rem;
            color: #0d47a1;
        }
        
        .setting-option {
            margin-bottom: 1.5rem;
            position: relative;
        }
        
        .setting-option label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;
            color: #444;
        }
        
        .setting-option input[type="text"],
        .setting-option input[type="email"],
        .setting-option select,
        .setting-option textarea {
            width: 100%;
            padding: 10px 15px;
            border: 1px solid #e0e6ef;
            border-radius: 6px;
            font-size: 0.95rem;
            transition: all 0.3s;
        }
        
        .setting-option input:focus,
        .setting-option select:focus,
        .setting-option textarea:focus {
            border-color: #1a73e8;
            outline: none;
            box-shadow: 0 0 0 2px rgba(26, 115, 232, 0.2);
        }
        
        .switch {
            position: relative;
            display: inline-block;
            width: 60px;
            height: 34px;
        }
        
        .switch input {
            opacity: 0;
            width: 0;
            height: 0;
        }
        
        .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #ccc;
            transition: .4s;
            border-radius: 34px;
        }
        
        .slider:before {
            position: absolute;
            content: "";
            height: 26px;
            width: 26px;
            left: 4px;
            bottom: 4px;
            background-color: white;
            transition: .4s;
            border-radius: 50%;
        }
        
        input:checked + .slider {
            background-color: #1a73e8;
        }
        
        input:focus + .slider {
            box-shadow: 0 0 1px #1a73e8;
        }
        
        input:checked + .slider:before {
            transform: translateX(26px);
        }
        
        .save-btn {
            background: #1a73e8;
            color: white;
            border: none;
            padding: 10px 25px;
            border-radius: 6px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s;
        }
        
        .save-btn:hover {
            background: #0d47a1;
        }
        
        /* 模态框 */
        .modal {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            z-index: 1000;
            align-items: center;
            justify-content: center;
        }
        
        .modal.active {
            display: flex;
        }
        
        .modal-content {
            background: white;
            border-radius: 12px;
            padding: 2rem;
            width: 90%;
            max-width: 600px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
            max-height: 90vh;
            overflow-y: auto;
        }
        
        .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.5rem;
            padding-bottom: 1rem;
            border-bottom: 1px solid #eee;
        }
        
        .modal-title {
            font-size: 1.5rem;
            color: #0d47a1;
        }
        
        .close-modal {
            background: none;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            color: #666;
        }
        
        .user-detail-row {
            display: flex;
            margin-bottom: 15px;
            padding-bottom: 15px;
            border-bottom: 1px solid #f0f4f8;
        }
        
        .detail-label {
            width: 120px;
            font-weight: 500;
            color: #555;
        }
        
        .detail-value {
            flex: 1;
        }
        
        .detail-section {
            margin-bottom: 25px;
            background: #f9fbfe;
            padding: 15px;
            border-radius: 8px;
        }
        
        .detail-section h4 {
            margin-bottom: 15px;
            color: #0d47a1;
            padding-bottom: 8px;
            border-bottom: 1px dashed #d1e3f8;
        }
        
        .edit-form {
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid #e0e6ef;
        }
        
        .form-group {
            margin-bottom: 20px;
        }
        
        .form-group label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;
        }
        
        .form-group textarea {
            width: 100%;
            min-height: 100px;
            padding: 12px;
            border: 1px solid #e0e6ef;
            border-radius: 6px;
            font-family: 'Noto Sans SC', sans-serif;
        }
        
        .form-actions {
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            margin-top: 20px;
        }
        
        .btn {
            padding: 10px 20px;
            border-radius: 6px;
            font-weight: 500;
            cursor: pointer;
            border: none;
            transition: all 0.3s;
        }
        
        .btn-primary {
            background: #1a73e8;
            color: white;
        }
        
        .btn-primary:hover {
            background: #0d47a1;
        }
        
        .btn-secondary {
            background: #f0f7ff;
            color: #1a73e8;
            border: 1px solid #1a73e8;
        }
        
        .btn-secondary:hover {
            background: #e3f2fd;
        }
        
        .preview-panel {
            background: #f9fbfe;
            border-radius: 8px;
            padding: 15px;
            margin-top: 20px;
            border: 1px solid #e0e6ef;
            display: none;
        }
        
        .preview-panel.active {
            display: block;
        }
        
        .preview-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }
        
        .preview-title {
            font-weight: 500;
            color: #0d47a1;
        }
        
        .preview-content {
            line-height: 1.6;
        }
        
        .status-select {
            padding: 8px 12px;
            border-radius: 6px;
            border: 1px solid #e0e6ef;
            width: 100%;
        }
        
        /* 响应式设计 */
        @media (max-width: 992px) {
            .sidebar {
                width: 80px;
            }
            
            .admin-logo h1, .menu-item span {
                display: none;
            }
            
            .menu-item {
                justify-content: center;
                padding: 1rem;
            }
            
            .menu-item i {
                margin-right: 0;
                font-size: 1.2rem;
            }
        }
        
        @media (max-width: 768px) {
            .admin-container {
                flex-direction: column;
            }
            
            .sidebar {
                width: 100%;
                height: auto;
                position: relative;
            }
            
            .admin-header {
                flex-direction: column;
                align-items: flex-start;
                gap: 1rem;
            }
            
            .table-controls {
                flex-direction: column;
                align-items: flex-start;
                gap: 1rem;
            }
            
            .search-box {
                width: 100%;
            }
            
            .filters {
                width: 100%;
                flex-wrap: wrap;
            }
            
            .data-table {
                display: block;
                overflow-x: auto;
            }
        }
    .connect-info{
        text-align: left;
    }
</style>
